import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '../components/ui';
import { useSession } from '../lib/session';

function Booting() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg text-text-muted">
      <Spinner className="size-6" />
    </div>
  );
}

/** Tenant realm (staff) routes. */
export function RequireStaff() {
  const { status, realm } = useSession();
  const loc = useLocation();
  if (status === 'booting') return <Booting />;
  if (status !== 'authenticated') {
    if (loc.pathname === '/') return <Navigate to="/landing" replace />;
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  if (realm === 'super') return <Navigate to="/admin/tenants" replace />;
  return <Outlet />;
}

/** Super-admin realm routes. */
export function RequireSuper() {
  const { status, realm } = useSession();
  if (status === 'booting') return <Booting />;
  if (status !== 'authenticated' || realm !== 'super') return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}

/** Hides children when the current user lacks a permission. */
export function Can({ perm, children }: { perm: string; children: React.ReactNode }) {
  const can = useSession((s) => s.can);
  return can(perm) ? <>{children}</> : null;
}
